var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"zoombox-button",on:{"click":_vm.zoom}},[_c('bpb-icon',{attrs:{"icon":_vm.isZoomed ? 'i-magnify--minus' : 'i-magnify--plus',"label-path":_vm.isZoomed ? 'zoombox.zoom-out' : 'zoombox.zoom-in'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }